import React from "react";
import { IconButton } from "@material-ui/core";

interface MyPageAppBarIconButtonProps {
	label: string | any;
	children: any;
	onClick?: () => void;
}

const MyPageAppBarIconButton = (props: MyPageAppBarIconButtonProps) => {
	const { children, label, onClick } = props;

	return (
		<IconButton
			aria-label={label}
			aria-controls="menu-appbar"
			aria-haspopup="true"
			onClick={() => onClick && onClick()}
			color="inherit"
			edge="start"
		>
			{children}
		</IconButton>
	);
};

export default MyPageAppBarIconButton;
